import React, { useCallback } from 'react';

import {
  SET_TABLE_SETTINGS,
  useScreenDispatch,
  useScreenState,
} from '@gogame/screens';

import {
  useLoadHourlyTrackerTable,
  useLoadDrillTo,
} from 'scenes/Trackers/HourlyTracker/data';

import {
  SET_DRILL_PATH,
  REORDER_COLUMNS,
  COLLAPSE_COLUMNS,
  SET_COLOR_SCALES_COLUMNS,
  TOGGLE_COLUMN_PERCENTAGE,
} from 'scenes/Trackers/HourlyTracker/reducers';
import HourlyTrackerDataTable from './HourlyTrackerDataTable';

export default () => {
  const dispatch = useScreenDispatch();
  const {
    filtersCollection,
    tableSettings,
    searchQuery,
    drillPath,
    columns,
    ready,
  } = useScreenState();

  const { data, isLoading, isRefetching } = useLoadHourlyTrackerTable(
    {
      filtersCollection,
      tableSettings,
      searchQuery,
      drillPath,
      columns,
    },
    { ready: ready }
  );
  const renderDimensionId = data?.drillItems?.at(-1)?.dimension?.id;
  const renderDimensionName = data?.drillItems?.at(-1)?.dimension?.name;

  const { data: drillTo } = useLoadDrillTo({ drillPath });

  const handleChangeSettings = useCallback(
    (payload) => {
      dispatch({
        type: SET_TABLE_SETTINGS,
        payload: payload,
      });
    },
    [dispatch]
  );

  const handleChangeDrillPath = useCallback(
    (_, payload) => {
      dispatch({
        type: SET_DRILL_PATH,
        payload: payload,
      });
    },
    [dispatch]
  );

  const handleReorderColumns = useCallback(
    (payload) => {
      dispatch({
        type: REORDER_COLUMNS,
        payload: payload,
      });
    },
    [dispatch]
  );

  const handleCollapseColumn = useCallback(
    (payload) => {
      dispatch({
        type: COLLAPSE_COLUMNS,
        payload: payload,
      });
    },
    [dispatch]
  );
  const handleTogglePercentage = useCallback(
    ({ field }) => {
      dispatch({
        type: TOGGLE_COLUMN_PERCENTAGE,
        payload: field,
      });
    },
    [dispatch]
  );

  const handleChangeColorScalesColumns = useCallback(
    ({ field, isColorScale }) => {
      dispatch({
        type: SET_COLOR_SCALES_COLUMNS,
        payload: { columnName: field, isColorScale },
      });
    },
    [dispatch]
  );

  return (
    <HourlyTrackerDataTable
      rows={data.rows}
      count={data.count}
      columns={data.columns}
      drillItems={data?.drillItems}
      compareMode={data?.compareMode}
      isLoading={isLoading}
      isRefetching={isRefetching}
      onChangeSettings={handleChangeSettings}
      onChangeDrillPath={handleChangeDrillPath}
      onReorder={handleReorderColumns}
      onCollapse={handleCollapseColumn}
      onTogglePercentage={handleTogglePercentage}
      onChangeColorScalesColumns={handleChangeColorScalesColumns}
      drillTo={drillTo}
      dimension={renderDimensionId}
      dimensionName={renderDimensionName}
    />
  );
};
